import { useQuery } from '@tanstack/react-query';

import { tvpil } from '../compat/tvpil';
import { queryKeys } from '../queryKeys';

import { fetchFavoriteChannels } from './fetchFavoriteChannels';

export function useFavoriteChannels() {
  const { isLoading, data, error } = useQuery({
    queryKey: queryKeys.favoriteChannels,
    queryFn: () => fetchFavoriteChannels(),
    staleTime: tvpil.favoritesTtl,
  });

  return {
    isLoading,
    favoriteChannels: data?.favoritePositions,
    error,
  };
}
